import { render, staticRenderFns } from "./SignatureInput.vue?vue&type=template&id=8a040c80&scoped=true&"
import script from "./SignatureInput.vue?vue&type=script&lang=js&"
export * from "./SignatureInput.vue?vue&type=script&lang=js&"
import style0 from "./SignatureInput.vue?vue&type=style&index=0&id=8a040c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a040c80",
  null
  
)

export default component.exports